import { Controller } from '@hotwired/stimulus'

/**
 * Contact Tracking Controller
 *
 * Tracks user engagement with contact methods (phone, chat, forms).
 * Uses the Analytics wrapper for consistent cross-platform tracking.
 *
 * Usage:
 *   <a href="tel:+18008755285"
 *      data-controller="contact-tracking"
 *      data-action="click->contact-tracking#trackClickToCall">
 *     (800) 875-5285
 *   </a>
 *
 *   <button data-controller="contact-tracking"
 *           data-action="click->contact-tracking#trackLiveChat">
 *     Start Live Chat
 *   </button>
 */
export default class extends Controller {
  /**
   * Track click-to-call phone number clicks
   */
  trackClickToCall() {
    this.#track('Click to Call')
  }

  /**
   * Track contact form question submissions
   */
  trackQuestionSubmit() {
    this.#track('Question Submitted')
  }

  /**
   * Track "Call Me Now" button clicks (engagement, not conversion)
   */
  trackCallMeNow() {
    this.#track('Call Me Now Clicked')
  }

  /**
   * Track live chat start
   */
  trackLiveChat() {
    this.#track('Live Chat Started')
  }

  // Private helper to send tracking via Analytics wrapper
  #track(action) {
    if (window.Analytics) {
      window.Analytics.track('Contact Engagement', { action })
    }
  }
}


